import React from 'react';
import { FaBookReader, FaClock } from 'react-icons/fa';
import { GiWeightLiftingUp } from 'react-icons/gi';

class TrialCTA extends React.Component {
    render() {
      return (
        <section className="bg-gray-50 py-16">
          <div className="max-w-6xl mx-auto px-4 text-center">
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-3xl font-bold mb-6">
                O Que Você Recebe no Seu Teste Grátis:
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                <div>
                  <GiWeightLiftingUp className="text-blue-500 text-4xl mx-auto mb-4" />
                  <h3 className="text-xl font-semibold">Acesso Completo ao App</h3>
                  <p className="text-gray-600">14 Dias de Treinos + Acompanhamento + Suporte de Coach</p>
                </div>
                <div>
                  <FaBookReader className="text-blue-500 text-4xl mx-auto mb-4" />
                  <h3 className="text-xl font-semibold">eBook Gratuito</h3>
                  <p className="text-gray-600">"Dieta Sustentável para Perda de Gordura" (Valor de R$49)</p>
                </div>
                <div>
                  <FaClock className="text-blue-500 text-4xl mx-auto mb-4" />
                  <h3 className="text-xl font-semibold">Sem Riscos</h3>
                  <p className="text-gray-600">Cancele a qualquer momento antes de 14 dias</p>
                </div>
              </div>
              <a 
                href="https://training-app.short.gy/train-with-diego-trainer" 
                target="_blank" 
                rel="noopener noreferrer"
                >
              <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-lg text-lg">
                Comece o Teste Grátis & Baixe o eBook Agora
              </button>
              </a>
              {/* <p className="mt-4 text-sm text-gray-500">
                Não é necessário cartão de crédito para garantir o eBook
              </p> */}
            </div>
          </div>
        </section>
      );
    }
}

export default TrialCTA;
